import React from 'react';
import PropTypes from 'prop-types';
import './Hero.css';

const Hero = ({ property }) => {
    const { name, title, masthead } = property;

    return (
        <section className="hero property-detail-hero" style={{ backgroundImage: `url(${process.env.RAZZLE_ASSET_URL}${masthead})` }}>
            <div className="hero-body">
                <div className="container">
                    <div className="columns">
                        <div className="column is-8-tablet is-offset-1-tablet is-7-desktop is-6-widescreen">
                            <div className="title-wrapper animated fadeInLeft">
                                <div className="pre-title">{name}</div>
                                <div className="big-title">
                                    {title.trim() === '' ? <div>Hudson Pacific Properties</div> : property.title}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

Hero.propTypes = {
    property: PropTypes.shape({
        name: PropTypes.string.isRequired,
        masthead: PropTypes.string,
        title: PropTypes.string,
        web_photos: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
};

export default Hero;
